import { render, staticRenderFns } from "./WsNoDataMessage.vue?vue&type=template&id=04c99d74&"
import script from "./WsNoDataMessage.vue?vue&type=script&lang=js&"
export * from "./WsNoDataMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports